/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 데스크탑의 페이지네이션을 컨트롤 및 렌더하는 컴포넌트입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import { HideText } from 'common-modules/general/assets/Styles/Common.style';
import { NextArrowIcon, NextDoubleArrowIcon, PrevArrowIcon, PrevDoubleArrowIcon } from 'common-modules/general/Common/Components/Icon';
import React, { useState } from 'react';
import styled from 'styled-components/macro';

const PaginationWrap = styled.div`
  text-align: center;
  font-size: 0;
  margin: 4rem 0;
`;
const Item = styled.div`
  position: relative;
  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0 0.3125rem;
  cursor: pointer;
`;

const ListItem = styled.div`
  display: inline-block;
  margin: 0 1.25rem;
`;

const PageItem = styled.a`
  display: inline-block;
  width: 1.25rem;
  height: 2.25rem;
  margin: 0 0.625rem;
  padding: 0.375rem 0.1875rem;
  font-size: 1.125rem !important;
  cursor: pointer;
  &.on {
    border-bottom: 2px solid #ff671d;
    font-family: 'SDGothicNeobTTF-eSm';
  }
  &:hover,
  &:focus {
    border-bottom: 2px solid #ff671d;
  }
`;

const Text = styled.span``;

interface Props {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalCount: number;
  limit: number;
}

const Pagination = ({ currentPage, setCurrentPage, totalCount, limit }: Props) => {
  const [curPageGroup] = useState<number>(1);
  const [pageGroupSize] = useState<number>(5);

  const maxPage = Math.floor(totalCount / limit) + (totalCount % limit > 0 ? 1 : 0);

  const renderPage = () => {
    const start = pageGroupSize * (curPageGroup - 1);
    const end = start + pageGroupSize > maxPage ? maxPage : start + pageGroupSize;

    const retArray: any = [];

    for (let loop = start + 1; loop <= end; loop++) {
      retArray.push(loop);
    }

    return retArray;
  };

  const handleFirst = () => {
    handleActivePage(1);
  };

  const handleLast = () => {
    handleActivePage(maxPage);
  };

  const handleActivePage = (page: number) => {
    if (page > 0 && page <= maxPage) {
      setCurrentPage(page);
    }
  };

  return totalCount === 0 ? null : (
    <PaginationWrap>
      <Item onClick={handleFirst}>
        <HideText>첫번째 페이지</HideText>
        <PrevDoubleArrowIcon aria-hidden="true"></PrevDoubleArrowIcon>
      </Item>
      <Item onClick={() => handleActivePage(currentPage - 1)}>
        <HideText>이전 페이지</HideText>
        <PrevArrowIcon aria-hidden="true"></PrevArrowIcon>
      </Item>
      <ListItem>
        {renderPage().map((num, index) => {
          return (
            <PageItem key={index} onClick={() => handleActivePage(num)} className={num === currentPage ? 'on' : ''}>
              <Text>{num}</Text>
            </PageItem>
          );
        })}
      </ListItem>
      <Item onClick={() => handleActivePage(currentPage + 1)}>
        <HideText>다음 페이지</HideText>
        <NextArrowIcon></NextArrowIcon>
      </Item>
      <Item onClick={handleLast}>
        <HideText>마지막 페이지</HideText>
        <NextDoubleArrowIcon></NextDoubleArrowIcon>
      </Item>
    </PaginationWrap>
  );
};

export default Pagination;
